import {  map, mergeMap } from 'rxjs/operators'
import { EMPTY, of } from 'rxjs'
// import { GeneralEpicActionType, baseFilter, CONSTS } from './base'
import { Action } from 'redux';



import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import appReducer, { BaseAction } from '../reducers/appReducer';
import { IRootState, UpdateDataPaths } from '../typings/shared';
export enum HelloEpicActionTypes {
    SAY_HELLO = 'SAY_HELLO',
    SAY_BYE = 'SAY_BYE',
    ENSURE_HELLO_IMG = 'ENSURE_HELLO_IMG'
}

type SayHelloPayload = {
    msg: string
}

type SayByePlayload = {
    msg: string
};


export interface SayHelloAction extends BaseAction<SayHelloPayload, HelloEpicActionTypes.SAY_HELLO> { }
export interface SayByeAction extends BaseAction<SayByePlayload, HelloEpicActionTypes.SAY_BYE> { }
export interface EnsureHelloImgAction extends Action<HelloEpicActionTypes.ENSURE_HELLO_IMG> { }

export default {
    actions: {
        doSayHello: (msg: string): SayHelloAction => ({ type: HelloEpicActionTypes.SAY_HELLO, payload: { msg } }),
        doSayBye: (msg: string): SayByeAction => ({ type: HelloEpicActionTypes.SAY_BYE, payload: { msg } }),
        doEnsureHelloImg: (): EnsureHelloImgAction => ({ type: HelloEpicActionTypes.ENSURE_HELLO_IMG }),
    },
    Epics: {
        ensureHelloImgEpic: (action$: ActionsObservable<EnsureHelloImgAction>, state$: StateObservable<IRootState>) => action$.pipe(
            ofType(HelloEpicActionTypes.ENSURE_HELLO_IMG),
            mergeMap(() => {
                if (state$.value.app.helloImg !== null) {
                    return EMPTY
                } else {
                    return of(appReducer.actions.getGeneralUpdateAction(UpdateDataPaths.loadingHelloImg, true))
                }
            })
        ),
        // loadingHelloImgEpic: (action$: ActionsObservable<GeneralUpdateAction>) => action$.pipe(
        //     filter((action: GeneralUpdateAction) => {
        //         if (action.payload === undefined) return false;
        //         // debugger;
        //         let { type, payload: { value, path } } = action;
        //         return type === appReducer.actionTypes.UPDATE && path === UpdateDataPaths.loadingHelloImg && value === true;
        //     }),
        //     mergeMap(() => {
        //         return of(
        //             appReducer.actions.getGeneralUpdateAction(UpdateDataPaths.helloImg, 'https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=401&q=80'),
        //         ).pipe(
        //             delay(4000),
        //             mergeMap(
        //                 (newAction) => of(newAction, appReducer.actions.getGeneralUpdateAction(UpdateDataPaths.loadingHelloImg, false))
        //             )
        //         )
        //     })
        // ),
        byeEpic: (action$: ActionsObservable<SayByeAction>) => action$.pipe(
            ofType(HelloEpicActionTypes.SAY_BYE),
            map((action: SayByeAction) => appReducer.actions.getGeneralUpdateAction(UpdateDataPaths.byeMsg, action.payload.msg))
        ),
    }
};
